import { AccessTimeFilled, Check } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { stripHtmlTags, truncateHtmlText } from "../helpers/htmlToText";

const CustomClickableQuestionsCard = ({
  icon,
  title,
  details,
  date,
  status,
  navigateTo,
  cardData,
}) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: { xs: "1.3em .7em", md: "1.3em 2.5em" },
        backgroundColor: theme.palette.mode === "dark" ? "#1e1e1e" : "#fff",
        width: "100%",
        border: `1px solid ${theme.palette.mode === "dark" ? "#3a3a3a" : "#DAD9D7"}`,
        borderRadius: "11px",
        marginBottom: ".7em",
        gap: 1,
      })}
    >
      <Box
        sx={{ display: "flex", alignItems: "center", gap: 1, width: "100%" }}
      >
        <Box sx={{ width: "2.6em", minWidth: { xs: "1.8em", md: "2.4em" } }}>
          <img src={icon} alt="" style={{ width: "100%" }} />
        </Box>
        <Box
          sx={{
            margin: { xs: "0.4em 0", md: "0 1em" },
            cursor: "pointer",
            width: "100%",
          }}
          onClick={() => {
            navigate(navigateTo, { state: { cardData } });
          }}
        >
          <Typography
            variant="h4"
            sx={{ fontSize: "1.15rem", fontWeight: 700, color: "text.primary" }}
          >
            {stripHtmlTags(title)}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              fontSize: { xs: ".75rem", md: "1.13rem" },
              fontWeight: 400,
              color: "text.secondary",
              margin: ".4em 0",
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {truncateHtmlText(details)}
          </Typography>
          <Typography
            variant="caption"
            sx={{
              fontSize: { xs: ".75rem", md: "1rem" },
              fontWeight: 400,
              color: "text.disabled",
            }}
          >
            {date}
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          padding: ".4em 1em",
          backgroundColor:
            status === "approved"
              ? "#4BB34B"
              : status === "pending"
              ? "#FFCC00"
              : "#95969D",
          borderRadius: "20px",
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        <Box
          sx={{
            backgroundColor: "#fff",
            borderRadius: "50px",
            padding: ".1em",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {status === "approved" ? (
            <Check sx={{ color: "#4BB34B", fontSize: "1rem" }} />
          ) : status === "pending" ? (
            <AccessTimeFilled sx={{ color: "#FFCC00", fontSize: "1rem" }} />
          ) : (
            <AccessTimeFilled sx={{ color: "#95969D", fontSize: "1rem" }} />
          )}
        </Box>
        <Typography
          variant="body2"
          sx={{ fontSize: "1rem", color: "#fff", textTransform: "capitalize" }}
        >
          {status}
        </Typography>
      </Box>
    </Box>
  );
};

export default CustomClickableQuestionsCard;
